import { Progress } from 'antd'
import React from 'react'

const StatusBreakdownCard = ({ title, value, icon: Icon, variant = "pending", percent, iconColor }) => {
    return (
        <div className={`status-breakdown-item-container ${variant}`}>
            <div className='status-breakdown-header'>
                <Icon size={22} color={iconColor} />
                <span className="breakdown-value">{value}</span>
            </div>
            <div>
                <span className="breakdown-label">{title}</span>
                <Progress percent={percent} showInfo={false} strokeColor={iconColor} />
                <span className="metric-label" style={{ paddingBottom: 0, marginBottom: 0, fontSize: '12px' }}>{percent}% of total</span>
            </div>
        </div>
    )
}

export default StatusBreakdownCard